export enum AppRoutes {
  LOGIN = 'connexion',
  HOME = 'accueil',
  USERS = 'utilisateurs',
  LOGS = 'logs',
}
